import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ToggleColorModeProvider from "./utils/ToggleColorMode";
import CssBaseline from "@mui/material/CssBaseline";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<ToggleColorModeProvider>
		<CssBaseline />
		<App />
	</ToggleColorModeProvider>
);
